import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getInhabitantsFromContractIDOptions } from '../Contract.api'

import { toContractSelectItems } from './ContractSelect.utils'

function ContractSelect({
  Control = InputSelectControl,
  apiParams,
  getData = getInhabitantsFromContractIDOptions,
  getDataItems = getItemsFromIdwellApiResponse,
  toPreparedItems = toContractSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      apiParams={apiParams}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default ContractSelect
